import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { CacheService } from '@mommy/services/cache.service';
import { UtilService } from '@mommy/services/util.service';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs/operators';
import { AppSettings } from '../../app.settings';
import { Api } from '../api';
import { QUERY_HOSPITAL_DETAIL, QUERY_HOSPITAL_LIST } from './hospital.graphql';

@Injectable({ providedIn: 'root' })
export class HospitalService {
  constructor(
    private api: Api,
    private apollo: Apollo,
    private util: UtilService,
    private cacheService: CacheService
  ) {}

  // 取得藥局列表
  getHospitalList() {
    console.log('getHospitalList');
    return new Promise(async (resolve, reject) => {
      let cursor = await this.cacheService.getDataCursor2(
        AppSettings.CACHE_KEY_HOSPITAL_LIST
      );
      console.warn('hospitals cursor', cursor);
      cursor = cursor ? cursor : 0;

      this.apollo
        .watchQuery<{ getHospitalList: any[] }>({
          query: QUERY_HOSPITAL_LIST,
          fetchPolicy: 'network-only',
          variables: {
            updated_at: cursor, //最近一筆的timestamp
          },
        })
        .valueChanges.pipe(take(1))
        .subscribe(
          async ({ data, loading }) => {
            console.log('loading', loading);
            console.log('data', data);

            if (data) {
              // loading = false; //如果有data,表示有cache
              if (data?.getHospitalList.length > 0) {
                try {
                  const new_data = await this.cacheService.mergeData2(
                    data?.getHospitalList,
                    AppSettings.CACHE_KEY_HOSPITAL_LIST,
                    'hospital_id'
                  );
                  resolve(new_data);
                } catch (error) {
                  console.error('cacheService merge data error', error);
                  reject(-1);
                }
              } else {
                console.log('no new data need to merge..');
                reject('no new data need to merge');
              }
            } else {
              reject('data is null');
            }
          },
          ({ graphQLErrors, networkError }) => {
            const msg = this.util.getErrorDesc(graphQLErrors, networkError);
            this.util.showToast(msg, '', 0, true);
            reject(-1);
          }
        );
    });
  }

  // 取得藥局資料
  getHospitalDetail(hospital_id: number) {
    return new Promise(async (resolve, reject) => {
      this.apollo
        .watchQuery<{ getHospital: any[] }>({
          query: QUERY_HOSPITAL_DETAIL,
          fetchPolicy: 'network-only',
          variables: {
            hospital_id,
          },
        })
        .valueChanges.pipe(take(1))
        .subscribe(
          ({ data, loading }) => {
            console.log('loading', loading);
            console.log('data', data);

            if (data) {
              // loading = false; //如果有data,表示有cache
              if (data?.getHospital) {
                resolve(data?.getHospital);
              } else {
                console.log('no new data need to merge..');
                reject('no new data need to merge');
              }
            } else {
              reject('data is null');
            }
          },
          ({ graphQLErrors, networkError }) => {
            console.log('graphQLErrors', graphQLErrors);
            console.log('networkError', networkError);
            reject(-1);
          }
        );
    });
  }

  // 取得藥局資料 by referral_code
  getHospitalDetailByReferralCode(referral_code: string) {
    const endpoint = `v1/platform/code-referral2/${referral_code}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = (await this.api
          .get(endpoint, null)
          .toPromise()) as any;
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        if (error.status !== 304) {
          console.error('getHospitalDetailByReferralCode error', error);
        }
        reject(error);
      }
    });
  }
}
